import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { Box, Chip, FormControl, FormHelperText, FormLabel, IconButton, TextField } from "@mui/material";

import TextFieldWithButton from "../../../../../shared/Form/TextFieldWithButton";

import { AddTalentReviewCandidate } from "../../../types/addReviewCandidate";
import { DeleteTagButtonIcon, EditPinButtonIcon } from "../../../assets/icons/components-icons";

const FinalNarrativeTagsStep = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal" });
  const { t: tErrors } = useTranslation("goHire", { keyPrefix: "components.reviewCandidateModal.validations" });
  const { control } = useFormContext<AddTalentReviewCandidate>();
  const [tag, setTag] = useState<string>("");

  return (
    <Box sx={[styles.container, styles.containerPadding]}>
      <Controller
        name="ginoSummary"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <FormControl sx={styles.formControl}>
              <FormLabel>{t("ginoSummary")}</FormLabel>
              <TextField
                {...field}
                fullWidth
                placeholder={t("writeYourNotesHere")}
                multiline
                rows={3}
                sx={styles.ginoSummaryField}
                error={!!error}
              />
              {/* <IconButton sx={styles.editPinButton} size="small">
                <EditPinButtonIcon />
              </IconButton> */}
            </FormControl>
            {error && <FormHelperText error>{tErrors(error.message)}</FormHelperText>}
          </>
        )}
      />

      <Controller
        name="tags"
        control={control}
        render={({ field, fieldState: { error } }) => {
          const handleAddTag = () => {
            const newTag = tag.trim();
            if (!newTag || field.value?.includes(newTag)) return;
            field.onChange([...(field.value || []), newTag]);
            setTag("");
          };

          return (
            <FormControl>
              <FormLabel>{t("addTagsKeywords")}</FormLabel>
              <TextFieldWithButton
                placeholder={t("tagsPlaceholder")}
                addButtonText={t("add")}
                addButtonAction={handleAddTag}
                value={tag}
                onChange={(e) => setTag(e.target.value)}
              />

              <Box sx={styles.tagsContainer}>
                {(field.value ?? []).map((t) => (
                  <Chip
                    key={t}
                    label={t}
                    variant="outlined"
                    sx={styles.tagChip}
                    deleteIcon={<DeleteTagButtonIcon />}
                    onDelete={() => {
                      field.onChange(field.value?.filter((tag) => tag !== t));
                    }}
                  />
                ))}
              </Box>

              {error && <FormHelperText error>{tErrors(error.message)}</FormHelperText>}
            </FormControl>
          );
        }}
      />
    </Box>
  );
};

export default FinalNarrativeTagsStep;

const styles = {
  containerPadding: {
    px: "24px",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  tagsContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    flexWrap: "wrap",
  },
  tagChip: {
    height: "fit-content",
    border: "1px solid var(--Gray-200, #E4E7EC)",
    background: "var(--Base-White, #FFF)",
    padding: "2px 10px",
    borderRadius: "6px",
    alignItems: "center",
    gap: "5px",
    "& .MuiChip-label": {
      padding: "0",
    },
    "& .MuiChip-deleteIcon": {
      margin: "0",
      alignSelf: "center",
    },
  },

  ginoSummaryField: {
    "& .Mui-disabled": {
      backgroundColor: "transparent !important",
      cursor: "not-allowed !important",
    },
    "& .MuiInputBase-root": {
      padding: "0 !important",
    },
    "& .MuiOutlinedInput-root": {
      border: "none",
      padding: "0",

      "& .MuiInputBase-input": {
        padding: "0",
      },
    },
  },
  editPinButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
  },
  formControl: {
    position: "relative",
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid var(--Gray---100, #E7E7E7)",
  },
};
